import getConfig from 'next/config';
import parseUrl from 'url-parse';

export const isMatchingPath = paths =>
  paths
    .map(path => parseUrl(path, {}).pathname)
    .every((pathname, _, pathnames) => pathname === pathnames[0]);

export const getLoggingUri = () => {
  const { publicRuntimeConfig = {} } = getConfig() || {};
  const { logPath = '' } = publicRuntimeConfig;

  return window.location.origin + logPath;
};

export const getRaidersLandingPageUri = () => {
  return '/raiders';
};

/**
 * Function to check if a url is internal or not
 */
export const isInternalUrl = href => {
  //Using try catch to handle scenarios incase invalid URLs occur
  try {
    const host = new URL(href).hostname;
    return host === 'www.allegiantair.com';
  } catch (error) {
    return false;
  }
};
